/**
 * "Label printer agent: seen 12 s ago", or red when it has gone quiet.
 *
 * The agent polls WordPress every 5 seconds and WordPress records the time. This pill only
 * compares that time with now, once a second, so the number counts up between refetches
 * and a dead agent turns red without waiting for the next poll.
 */
import { useEffect, useState } from 'react';
import { Pill } from '@/components';
import { agentSeenMs, agentStatus } from './labels';
import type { VialAgent } from './types';

export function AgentPill({ agent }: { agent: VialAgent | null | undefined }) {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, []);

  const status = agentStatus(agent ? agentSeenMs(agent.seen_at) : null, now);
  const detail = agent?.printer ? `Printer ${agent.printer}` : undefined;

  return (
    <span className="bench-agent" role="status" aria-live="polite">
      <Pill tone={status.tone} {...(detail ? { title: detail } : {})}>
        {status.text}
      </Pill>
    </span>
  );
}
